module.exports = __webpack_public_path__ + "static/media/test7_4.ca5f2165.png";